
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Header extends Vue {
  @Prop() prefix!: string;
  @Prop() content!: string;
}
